import styled, { css } from 'styled-components';
import { IButtonStyled } from './../../../../common/interfaces/buttons';

export const StyledButton = styled.button<IButtonStyled>(({ theme, padding, borderRadius, ghostVariant }) => {
  const disableHoverStyle = ghostVariant === 'fuchsia';

  return css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${padding};
    border: none;
    background-color: ${theme.colorToken.transparent};
    border-radius: ${borderRadius};
    cursor: pointer;
    gap: ${theme.spacing['8']};

    &:hover {
      background-color: ${disableHoverStyle ? theme.colorToken.transparent : theme.colorToken.interactiveLight};
    }
    &:active {
      background-color: ${disableHoverStyle ? theme.colorToken.transparent : theme.colorToken.borderInteractive};
    }
  `;
});
